import styled from 'styled-components';
import { colors } from 'styles/colors';

export const BigNumbersContainer = styled.div`
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;
  padding: 24px 16px;

  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  align-items: start;

  @media (max-width: 768px) {
    gap: 0;
    padding-top: 0;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    margin: 0 -16px;
    overflow-x: hidden;
  }

  overflow-x: auto;
  order: 0;
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 8px;
  text-align: left;
  margin: -12px;

  & > span {
    font-weight: 400;
    color: ${colors.text['white-0']};
  }
`;

export const UnitsTooltipContent = styled(TooltipContent)`
  margin: 0;

  & > div > span {
    font-size: 12px;
  }

  & > div > span:nth-child(1) {
    font-weight: 500;
    font-size: 14px;
  }

  & > h3 {
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    color: ${colors.text['white-0']};
  }
`;

export const GenericDescriptionTooltipContent = styled(TooltipContent)`
  width: 166px;
  height: 50px;

  & > span {
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
    text-align: center;
  }
`;

export const HealthyDescriptionTooltipContent = styled(GenericDescriptionTooltipContent)`
  height: 60px;
`;

export const AvailabilityDescriptionTooltipContent = styled(GenericDescriptionTooltipContent)`
  height: 95px;
`;

export const UnitTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    & > div:first-of-type {
      overflow-x: auto;
    }
  }
`;

export const UnitsTooltipTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: ${colors.text['white-0']};
`;

export const UnitsTooltipSectionTitle = styled.p`
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 700;
  color: ${colors.text['white-0']};
`;

export const UnitsTooltipTable = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

export const UnitsTooltipHeaderRow = styled.th`
  border: 1px solid ${colors.stroke['soft-200']};
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.text['white-0']};
  white-space: nowrap;
`;

export const UnitsTooltipRow = styled.td<{ $small?: boolean }>`
  border: 1px solid ${colors.stroke['soft-200']};
  padding: 6px 10px;
  font-size: ${({ $small }) => ($small ? '10px' : '12px')};
  color: ${colors.text['white-0']};
  white-space: nowrap;
`;
